import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes/appRoutes'; 
import { EventsProvider } from './contexts/EventContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// יצירת QueryClient
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// ייבוא כלי Debug לשמירה אוטומטית (רק בפיתוח)
if (process.env.NODE_ENV === 'development') {
  import('./utils/debugAutoSave');
}


const root = ReactDOM.createRoot(
  
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <EventsProvider>
        <BrowserRouter>
          <AppRoutes /> 
         
              {/* <TreatySignRouts/>  */}
           
                
        </BrowserRouter>
      </EventsProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
